import { Layout, Section } from 'layout';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import LandingScreen from './screens/landing-screen';
import ProductListScreen from './screens/product-list-screen';
import SupplierDetailScreen from './screens/supplier-detail-screen';
import SupplierListScreen from './screens/supplier-list-screen';

const SupplierIntelligencePage = () => {
  const match = useRouteMatch();

  return (
    <Layout type={'sidebar_page_layout'}>
      <Section name={'content'}>
        <Switch>
          <Route exact path={`${match.url}`} component={LandingScreen} />
          <Route exact path={`${match.url}/suppliers`} component={SupplierListScreen} />
          <Route path={`${match.url}/suppliers/:id`} component={SupplierDetailScreen} />
          <Route exact path={`${match.url}/products`} component={ProductListScreen} />
        </Switch>
      </Section>
    </Layout>
  );
};

export default SupplierIntelligencePage;
